// 存储组件的属性
const componentProperties = new Map();
// 引用 $imagePath
import $imagePath from "@/utils/imagePath.js";

// 数据版本  每次修改组件数据  需要对版本进行修改
// componentProperties.set('componentPropertiesVersion', 'V1.0.0')
// 详情页组件
componentProperties.set("detail", {
  component: "detail",
  text: "详情",
  type: "10-1",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "detailstyle",
  moduleName: "详情",
  setStyle: {
    moduleStyleType: 2, //1  详情1 
    moduleName: "详情",
    linkType: "10", //跳转类型  10 内部链接 11 外部链接
    http: {
      externalLink: "", //外部链接
      internalLink: "", //内部链接,
    },
  },
});
// 底部我的菜单页面组件数据 只用于数据处理 不用于拖拽
componentProperties.set("my", {
  component: "my",
  text: "我的",
  type: "11-1",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "mystyle",
  moduleName: "我的",
  setStyle: {
    moduleName: "我的",
    moduleStyleType: 1, //代表我的默认布局
    linkType: "10", //跳转类型  10 内部链接 11 外部链接
    // http: {
    //   externalLink: "", //外部链接
    //   internalLink: "", //内部链接,
    // },
  },
})
// 标题文本
componentProperties.set("captiontext", {
  component: "captiontext",
  text: "标题文本",
  type: "1-1",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "captiontextsstyle",
  moduleName: "标题文本",
  setStyle: {
    moduleName: "标题文本",
    parentComponent: "captiontext",
    text: "标题文本",
    name: "标题文本", //标题内容
    description: "", //描述内容
    fontFamily: "Microsoft YaHei", //字体
    wordSize: 16, //标题大小
    descriptionSize: 12, //描述大小
    wordWeight: "normal", //标题粗细
    positions: "left", //显示位置  可选left/center
    descriptionWeight: "normal", //描述粗细
    wordColor: "rgba(50, 50, 51, 10)", //标题颜色
    descriptionColor: "rgba(150, 151, 153, 10)", //描述颜色
    backColor: "rgba(255, 255, 255, 10)", //背景颜色
    defaultBackColor: "rgba(255, 255, 255, 10)", //默认背景颜色
    borderBott: false, //底部分割线
    wordHeight: 24, //框体高度
    linkType: "10", //跳转类型  10 内部链接 11 外部链接
    more: {
      //查看更多
      show: false, //是否显示查看更多
      type: 1, // 样式选择
      text: "查看更多", //自定义文字
      httpType: 10, //链接类型
      http: {
        externalLink: "", //外部链接
        internalLink: "", //内部链接
      }, //链接
    },
  },
});
// 搜索组件
componentProperties.set("commoditysearch", {
  component: "commoditysearch",
  text: "搜索组件",
  type: "1-2",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "commoditysearchstyle",
  moduleName: "商品搜索",
  componentTop: 40, // 用于拖拽的组件右侧删除区域的距离顶部边缘的距离
  setStyle: {
    moduleName: "商品搜索",
    moduleStyleType: 1, // 选择模板  1 全圆角输入框  2  半圆角输入框
    parentComponent: "commoditysearch",
    fontFamily: "Microsoft YaHei", //字体
    text: "商品搜索",
    linkType: "10", //链接类型
    http: {
      externalLink: "", //外部链接
      internalLink: "", //内部链接,
    },
    placeholder: "请输入关键词",
    searchContent: "",
    heights: 28, //搜索栏高度
    position: "left", //显示位置 left center right
    sweep: false, // 显示扫一扫
    borderRadius: 10, //框体样式
    textPosition: 0, //文本位置
    backgroundColor: "", //背景颜色
    defaultBackgroundColor: "",
    borderColor: "#348CF8", //框体颜色
    defaultBorderColor: "#348CF8",
    textColor: "#b8b4b4", //字体颜色
    defaultTextColor: "#b8b4b4",
    hotords: [], //热词
    fontSize: 12,
  },
});
// 标题栏
componentProperties.set("titlebar", {
  component: "titlebar",
  text: "标题栏",
  type: "1-3",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "titlebarstyle",
  moduleName: "标题栏",
  setStyle: {
    moduleName: "标题栏",
    parentComponent: "titlebar",
    paddingTop: 0, // 标题栏距离顶部距离
    paddingBottom: 0, // 标题栏距离底部距离
    paddingLeft: 0, // 标题栏距离左侧距离
    paddingRight: 0, // 标题栏距离右侧距离
    bgColor: "rgb(255, 255, 255)", // 标题栏背景颜色
    defaultBgColor: "rgb(255, 255, 255)", // 默认标题栏背景颜色
    // 左侧竖线配置
    showLine: true, // 是否显示竖线
    lineWidth: "4px", // 竖线宽度
    lineColor: "", // 竖线颜色
    defaultLineColor: "#348CF8", // 默认竖线颜色
    lineMarginRight: "8px", // 竖线距离右侧距离
    iconType: "line", // // 图标类型：line 显示竖线  image  显示图标
    image: "star", // 图片图标地址
    iconSize: "18px", // iconfont大小
    iconWidth: "20px", // 图片宽度
    iconHeight: "20px", // 图片高度
    iconColor: "", // iconfont颜色（默认继承竖线颜色）
    iconMarginRight: "8px",
    text: "快捷服务", //    // 文本配置 标题
    textColor: "#4A4A4A", // 标题颜色
    defaultTextColor: "#4A4A4A",
    textSize: "16px", // 标题字体大小
    fontWeight: "bold", // 标题粗细
  },
});
// 图片广告
componentProperties.set("pictureads", {
  component: "pictureads",
  text: "图片广告",
  type: "1-4",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "pictureadsstyle",
  moduleName: "图片广告",
  setStyle: {
    moduleName: "图片广告",
    parentComponent: "pictureads",
    linkType: "10", //链接类型
    http: {
      internalLink: "",
      externalLink: "",
    },
    text: "图片广告",
    swiperType: 0, // 选择模板
    borderRadius: 0, // 图片倒角
    pageMargin: 0, // 页面边距
    imageMargin: 0, // 图片边距
    pagingType: 0, // 分页类型: 0/"bullets"/"fraction"/"progressbar"
    rowindividual: 2, // 一行个数
    imageList: [], // 添加图片
  },
});
// 图片+导航组
componentProperties.set("picturenavgroup", {
  component: "picturenavgroup",
  text: "图片+导航组",
  type: "1-5",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "picturenavgroupstyle",
  moduleName: "图片+导航组",
  setStyle: {
    moduleName: "图片+导航组",
    parentComponent: "picturenavgroup",
    text: "图片+导航组",
    swiperType: 0, // 选择模板
    pageMargin: 0, // 页面边距
    imageHeight: 190, // 图片高度
    pagingType: 0, // 分页类型: 0/"bullets"/"fraction"/"progressbar"
    rowindividual: 2, // 一行个数
    navigationType: 0, //导航组图片导航类型
    borderRadius: 10, //导航组图片倒角
    showSize: 5, //导航组一屏显示个数
    textHeight: 24, //导航组 字体高度
    textSize: 12, //导航组字体大小
    textColor: "rgb(0, 0, 0)", //导航组文字颜色
    imgStyle: 0, //图片样式
    isBack: true, //是否支持返回上一页面
    backgroundColor: "rgb(255, 255, 255)", //导航组背景颜色
    defaultBackgroundColor: "rgb(255, 255, 255)", // 默认导航组背景颜色
    textHeight: 24, // 字体高度
    bgImg:
      "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/19/2026-01-19MC10:18:492259626a392e4645a1844f0d8dee5af5.png", //默认图片背景
    pictureTitle: "智联科创园",
    pictureTitleTop: 73, // 图片标题距离顶部距离
    pictureTitleLeft: 44, // 图片标题距离左侧距离
    pictureTitleColor: "rgb(255, 255, 255)", // 图片标题颜色
    defaultPictureTitleColor: "rgb(255, 255, 255)", // 默认图片标题颜色
    pictureTitleSize: 20, // 图片标题大小
    pictureTitleWeight: "normal", // 图片标题粗细
    fontFamily: "Microsoft YaHei", //字体
    linkType: "10", //链接类型
    imageList: [
      {
        src: `${$imagePath.image0}`,
        text: "园区介绍",
        http: {
          internalLink: "",
          externalLink: "",
        },
        linktype: "10",
      },
      {
        src: `${$imagePath.image1}`,
        text: "招商管理",
        http: {
          internalLink: "",
          externalLink: "",
        },
        linktype: "10",
      },
      {
        src: `${$imagePath.image2}`,
        text: "园区咨询",
        http: {
          internalLink: "",
          externalLink: "",
        },
        linktype: "10",
      },
      {
        src: `${$imagePath.image3}`,
        text: "访客入园",
        http: {
          internalLink: "",
          externalLink: "",
        },
        linktype: "10",
      },
    ], // 图片导航列表
    navigationType: 0, //图片导航类型
  },
});
// 图文导航
componentProperties.set("graphicnavigation", {
  component: "graphicnavigation",
  text: "图文导航444",
  type: "1-6",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "graphicnavigationstyle",
  moduleName: "图文导航",
  isBack: true, //是否支持返回上一页面
  moduleName: "图文导航",
  setStyle: {
    parentComponent: "graphicnavigation",
    text: "图文导航444",
    linkType: "10", //链接类型
    imageList: [
      {
        src: "https://29367.s81i.faiusr.com/4/105/AFEIt_UBEAQYACCvuq3VBSjG8Mv4BDA-OC9AaQ.png",
        text: "园区介绍",
        linkType: "10", //链接类型
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
      {
        src: "https://29367.s81i.faiusr.com/4/105/AFEIt_UBEAQYACCvuq3VBSjG8Mv4BDA-OC9AaQ.png",
        text: "招商管理",
        linkType: "10", //链接类型
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
      {
        src: "https://29367.s81i.faiusr.com/4/105/AFEIt_UBEAQYACCvuq3VBSjG8Mv4BDA-OC9AaQ.png",
        text: "园区咨询",
        linkType: "10", //链接类型
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
      {
        src: "https://29367.s81i.faiusr.com/4/105/AFEIt_UBEAQYACCvuq3VBSjG8Mv4BDA-OC9AaQ.png",
        text: "访客入园",
        linkType: "10", //链接类型
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
    ], // 图片导航列表
    navigationType: 0, //图片导航类型
    imgStyle: 0, //图片样式
    backgroundColor: "rgb(255, 255, 255)", //背景颜色
    textColor: "rgb(0, 0, 0)", //文字颜色
    borderRadius: 0, //图片倒角
    showSize: 5, //一屏显示个数
    textHeight: 24, // 字体高度
    textSize: 12, // 字体大小
    bgImg: "",
    isBack: true, //是否支持返回上一页面
  },
});
//服务导航
componentProperties.set("servicenavigation", {
  component: "servicenavigation",
  text: "服务导航",
  type: "1-7",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "servicenavigationstyle",
  moduleName: "服务导航",
  isBack: true, //是否支持返回上一页面
  setStyle: {
    moduleName: "服务导航",
    parentComponent: "servicenavigation",
    text: "服务导航",
    textSize: 16, //主标题字体大小
    subFontSize: 12, //子标题字体大小
    linkType: "10", //链接类型
    imageList: [
      {
        src: $imagePath.image4,
        text: "访客预约",
        subText: "一键开启高效通行",
        textColor: "#233E64", //文字颜色
        borderColor: "#A3C8FD", //边框颜色
        lineColor: "#4079E1", //下划线颜色
        textSize: 16, //主标题字体大小
        subFontSize: 11, //子标题字体大小
        linktype: "10",
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
      {
        src: $imagePath.image5,
        text: "办公服务",
        subText: "一站式解决办公痛点",
        textColor: "#0C5351", //文字颜色
        borderColor: "#86D6D3", //边框颜色
        lineColor: "#1AAAA6", //下划线颜色
        textSize: 16, //主标题字体大小
        subFontSize: 11, //子标题字体大小
        linktype: "10",
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
      {
        src: $imagePath.image6,
        text: "政策咨询",
        subText: "一键获取触手可及",
        textColor: "#28357B", //文字颜色
        borderColor: "#ACB6E8", //边框颜色
        lineColor: "#2C45CB", //下划线颜色
        textSize: 16, //主标题字体大小
        subFontSize: 11, //子标题字体大小
        linktype: "10",
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
    ],
  },
});
// 横向标签
componentProperties.set("transversustag", {
  component: "transversustag",
  text: "横向标签",
  type: "3-1",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "transversustagstyle",
  moduleName: "横向标签",
  setStyle: {
    moduleName: "横向标签",
    text: "横向标签",
    parentComponent: "transversustag",
    moduleStyleType: 1, // 选择模板  1 下滑横线  2  右上角点  3正下方点 4右上角翅膀 5 正下方曲线
    activeIndex: 0, //默认选中标签项
    activeColor: "#348cf8", //选中标签项颜色
    defaultActiveColor: "#348cf8", //未选中默认标签颜色
    activeBackgroundColor: "#F9F9F9", //选中标签项背景颜色
    defaultActiveBackgroundColor: "#F9F9F9", //未选中默认标签项背景颜色
    offActiveColor: "#333333", //未选中标签项颜色
    defaultOffActiveColor: "#333333", //未选中默认标签项颜色
    offBackgroundColor: "#F9F9F9", //未选中标签项背景颜色
    defaultOffBackgroundColor: "#F9F9F9", //未选中默认标签项背景颜色
    fontSize: 12, //标签字号大小
    fontFamily: "Microsoft YaHei", //标签字体
    tagList: [
      {
        name: "标签1",
        type: 1,
        comList: [],
        comType: "none", //组件类型的名称
      },
      {
        name: "标签2",
        type: 2,
        comList: [],
        comType: "none", //组件类型的名称
      },
    ],
  },
});
// 文章列表
componentProperties.set("storenotecard", {
  component: "storenotecard",
  text: "文章列表",
  type: "3-2",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "storenotecardstyle",
  moduleName: "文章列表",
  setStyle: {
    moduleName: "文章列表",
    parentComponent: "storenotecard",
    text: "文章列表", //主标题
    name: "这里显示专题名称", //专题名称
    commodityType: 2, // 选择模板  2滚动列表  1  轮播图列表 4 竖列表
    fontFamily: "Microsoft YaHei", //主标题字体
    fontSize: 13, //主标题字号
    textColor: "#333333", //主标题文字颜色
    subFontFamily: "Microsoft YaHei", //副标题字体
    subFontSize: 11, //副标题字号
    subTextColor: "#333333", //副标题文字颜色
    moditystyle: 0, // 卡片样式选择
    borderRadius: 0, // 图片边角
    textWeight: 400, // 标题粗细
    isShowMore: true, //是否显示右侧查看更多内容
    moreText: "查看更多", //右侧单元格文字
    noteLabels: true, // 笔记标签
    readingNumber: true, // 阅读数
    praisePoints: true, //点赞数
    viewMore1: true, //更多1
    viewMore2: true, //更多2
    articleList: [], //文章列表
    checkedArticleList: [], //文章选择选中列表
    CategoryArticleList: [], //文章分类列表
    checkedCategoryList: [], //文章分类选择选中列表
    imageList: [
      // {
      //   src: `${$imagePath.image7}`,
      //   text: "这里显示主标题名称1",
      //   subTitle: "注释文案", //副标题
      //   description: "一段内容一段内容一段内容一段内容一段内容一段内容", //描述
      //   http: {
      //     internalLink: "",
      //     externalLink: "",
      //   },
      // },
    ],
    positions: "bottom", //标题位置
    linktype: "10",
    http: {
      externalLink: "", //外部链接
      internalLink: "", //内部链接,
    },
    linkDetail: {
      //跳转详情
      moduleStyleType: 1, //1  详情1
      moduleName: "详情",
    },
  },
});

// 互动卡片
componentProperties.set("interactioncard", {
  component: "interactioncard",
  text: "互动卡片",
  type: "4-1",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "interactioncardstyle",
  moduleName: "互动卡片",
  setStyle: {
    moduleName: "互动卡片",
    parentComponent: "interactioncard",
    text: "互动卡片",
    buttonRadius: 30, //按钮倒角
    subTextColor: "#a1a1a1ff", //子标题颜色
    textColor: "#323232", //主标题文字颜色
    moduleType: 1, //模块样式类型
    backgroundColor: "rgb(255, 255, 255)", //背景颜色
    // 最新追加
    linkDetail: {
      //跳转详情
      moduleStyleType: 1, //1  详情1
      moduleName: "详情",
    },
    options: [
      //下拉列表
      {
        label: "携手联宝，共筑产业新生",
        value: 1,
      },
    ],
    optionsValue: 1, //下拉列表默认值
    imageList: [
      {
        text: "《职场沟通与高校写作》主题讲座",
        status: 0, //状态值  后续根据接口判断 0 未报名 1 已报名
        subText: "主讲人",
        wordText: "2025年8月14日",
        buttonText: "报名", //按钮文字
        textColor: "#233E64", //文字颜色
        borderColor: "#A3C8FD", //边框颜色
        lineColor: "#4079E1", //下划线颜色
        textSize: 16, //主标题字体大小
        subFontSize: 11, //子标题字体大小
        linkType: "10", //链接类型
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
      {
        text: "《职场沟通与高校写作》主题讲座",
        status: 0, //状态值  后续根据接口判断 0 未报名 1 已报名
        subText: "主讲人",
        wordText: "2025年8月14日",
        buttonText: "报名", //按钮文字
        textColor: "#233E64", //文字颜色
        borderColor: "#A3C8FD", //边框颜色
        lineColor: "#4079E1", //下划线颜色
        textSize: 16, //主标题字体大小
        subFontSize: 11, //子标题字体大小
        linkType: "10", //链接类型
        http: {
          internalLink: "",
          externalLink: "",
        },
      },
    ],
  },
});
// 公告
componentProperties.set("notice", {
  component: "notice",
  text: "公告",
  type: "1-8",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "noticestyle",
  moduleName: "公告",
  setStyle: {
    moduleName: "公告",
    parentComponent: "notice",
    text: "公告",
    fontFamily: "Microsoft YaHei", //主标题字体
    fontSize: 1, //主标题字号
    noticeText: "请填写内容，如果过长，将会在手机上滚动显示", //内容
    backColor: "rgb(255, 248, 233)", //背景颜色
    defaultBackColor: "rgb(255, 248, 233)", //默认文字颜色
    textColor: "rgba(100, 101, 102)", //文字颜色
    defaultTextColor: "rgba(100, 101, 102)", //默认文字颜色
    linktype: "10", //链接类型
    http: {
      externalLink: "", //外部链接
      internalLink: "", //内部链接,
    },
    image: "", //公告前置图标/图片
  },
});
componentProperties.set("listswitching", {
  component: "listswitching",
  text: "商品222",
  type: "2-1",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "listswitchingstyle",
  moduleName: "商品列表",
  setStyle: {
    text: "商品222",
    commodityType: 0,
    moditystyle: 0,
    borderRadius: 0,
    pageMargin: 15,
    commodityMargin: 10,
    textWeight: 400,
    positions: "left",
    priceofcommodity: true,
    purchasebutton: true,
    commoditycorner: true,
    purchasebuttonType: 0,
    commoditycornertype: 0,
    commodityTagColor: "#07c160",
    tagPosition: 0,
    imageList: [],
    purchase: "马上抢",
    commoditylisttype: 0,
    commoditylisttypetab: [
      {
        text: "分组",
        imageList: [],
      },
      {
        text: "分组",
        imageList: [],
      },
    ],
    tabColor: "#f39800",
    showMore: false,
    moreUrl: null,
    bgImg: "",
  },
});

componentProperties.set("richtext", {
  component: "richtext",
  text: "富文本555",
  type: "1-10",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "richtextstyle",
  setStyle: {
    text: "富文本",
    myValue: "", //富文本内容
    backColor: "rgb(249, 249, 249)", //背景颜色
  },
});
componentProperties.set("magiccube", {
  component: "magiccube",
  text: "魔方666",
  type: "1-6",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "magiccubestyle",
  setStyle: {
    text: "魔方",
    rubiksCubeType: 0, // 魔方类型
    pageMargin: 0, //页面间距
    imgMargin: 0, //图片间隙
    imageList: [
      {
        src: "",
        linktype: "10",
        http: {},
      },
      {
        src: "",
        linktype: "10",
        http: {},
      },
      {
        src: "",
        linktype: "10",
        http: {},
      },
      {
        src: "",
        linktype: "10",
        http: {},
      },
      {
        src: "",
        linktype: "10",
        http: {},
      },
    ], //图片列表
  },
});
componentProperties.set("auxiliarysegmentation", {
  component: "auxiliarysegmentation",
  text: "辅助分割",
  type: "1-11",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "auxiliarysegmentationstyle",
  setStyle: {
    text: "辅助分割",
    blankHeight: 30, //空白高度
    segmentationtype: 0, //分割类型
    paddType: 0, //边距
    auxliarColor: "rgb(229, 229, 229)", //辅助线颜色
    bordertp: "solid", //线的类型
  },
});

componentProperties.set("storeinformation", {
  component: "storeinformation",
  text: "店铺信息",
  type: "1-12",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "storeinformationstyle",
  setStyle: {
    text: "店铺信息",
    bakcgroundImg: "", //背景图片
    headPortrait: "", //店铺头像
    rubiksCubeType: 0, //类型
    name: "店铺名称", //店铺名称
    Discount: "在线支付满150减30，满100减20", //优惠信息
  },
});
componentProperties.set("entertheshop", {
  component: "entertheshop",
  text: "单元格",
  type: "1-13",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "entertheshopstyle",
  setStyle: {
    text: "单元格",
    icon: "", // 左侧图标
    shopName: "左侧标题",
    copywriting: "右侧内容",
    type: "10",
    http: {},
  },
});

componentProperties.set("videoss", {
  component: "videoss",
  text: "视频",
  type: "1-8",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "videostyle",
  setStyle: {
    text: "视频",
    src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4", // 视频地址
    coverUrl: null, // 封面地址
    autoplay: false, // 是否自动播放
  },
});

componentProperties.set("custommodule", {
  component: "custommodule",
  text: "自定义模块",
  type: "demo",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "custommodulestyle",
  setStyle: {
    text: "自定义模块",
    demo: "自定义内容",
    img: "https://img2.baidu.com/it/u=1905875968,4289754134&fm=26&fmt=auto&gp=0.jpg",
  },
});
componentProperties.set("communitypowder", {
  component: "communitypowder",
  text: "社群涨粉",
  type: "1-14",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "communitypowderstyle",
  setStyle: {
    text: "社群涨粉",
    mainImg: "", //入口图片
    qrcodeImg: "", //二维码
    title: "标题", //标题
    describe: "辅助描述", //描述
    buttonName: "立即添加", //按钮名称
    backColor: "rgb(255, 255, 255)", //背景颜色
  },
});

componentProperties.set("crowdoperation", {
  component: "crowdoperation",
  text: "人群运营",
  type: "1-17",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "crowdoperationstyle",
  setStyle: {
    text: "人群运营",
  },
});
componentProperties.set("personalizedrecommendation", {
  component: "personalizedrecommendation",
  text: "个性化推荐",
  type: "1-18",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "personalizedrecommendationstyle",
  setStyle: {
    text: "个性化推荐",
  },
});
componentProperties.set("onlineservice", {
  component: "onlineservice",
  text: "在线客服",
  type: "1-19",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "onlineservicestyle",
  setStyle: {
    text: "在线客服",
  },
});
componentProperties.set("investigate", {
  component: "investigate",
  text: "表单模块",
  type: "2-3",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "investigatestyle",
  setStyle: {
    text: "表单模块",
    title: "表单模块",
    jsonData: [], //value1为sass显示内容，value2为前端显示内容
  },
});
componentProperties.set("follow", {
  component: "follow",
  text: "关注公众号",
  type: "1-15",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "followStyle",
  setStyle: {
    text: "关注公众号",
    heade: "https://imgs.starfirelink.com/miniShop//logo_1618466110849.png",
    followName: "公众号名称",
    followAppId: "",
  },
});
componentProperties.set("suspension", {
  component: "suspension",
  text: "悬浮按钮",
  type: "1-16",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  style: "suspensionstyle",
  setStyle: {
    text: "悬浮按钮",
    linktype: "10",
    http: {},
  },
});

//底部导航
componentProperties.set("tabbar", {
  component: "tabbar",
  text: "底部导航",
  type: "2-1",
  active: true, //是否选中该组件
  isShow: true, //是否显示组件 用于显示隐藏该组件
  activeIndex: 0, //默认选中第一项
  style: "tabbarstyle",
  setStyle: {
    parentComponent: "tabbar",
    moduleType: 1, //模块样式切换
    text: "底部导航",
    backgroundColor: "#FFFFFF",
    activeColor: "#1989fa",
    inactiveColor: "#7d7e80",
    isShowBorder: true,
    iconWidth: "25",
    iconHeight: "25",
    fontSize: "14",
    Highlight: 0,
    active: 0, //底部导航栏选中项
    iconList: [
      {
        path: "home",
        isActive: true, //是否显示当前导航栏
        inactive: "wap-home",
        iconPic: "wap-home",
        iconName: "首页",
        iconText: "首页",
        isDot: false,
        linktype: "10",
        isShow: true, //默认选择首页
        http: {
          externalLink: "", //外部链接
          internalLink: "", //内部链接,
        },
      },
      {
        path: "notification",
        isActive: true, //是否显示当前导航栏
        inactive: "iconfont icon-tongzhi21",
        iconPic: "iconfont icon-tongzhi21",
        iconName: "通知",
        iconText: "通知",
        isDot: false,
        isShow: false, //默认选择首页
        linktype: "10",
        http: {
          externalLink: "", //外部链接
          internalLink: "", //内部链接
        },
      },
      {
        path: "activity",
        isActive: true, //是否显示当前导航栏
        inactive: "iconfont icon-huodongyaoyue",
        iconPic: "iconfont icon-huodongyaoyue",
        iconName: "活动",
        iconText: "活动",
        isDot: false,
        isShow: false, //默认选择首页
        linktype: "10",
        http: {
          externalLink: "", //外部链接
          internalLink: "", //内部链接
        },
      },
      {
        path: "user",
        isActive: true, //是否显示当前导航栏
        inactive: "iconfont icon-wode1-copy",
        iconPic: "iconfont icon-wode1-copy",
        iconName: "我的",
        iconText: "我的",
        isDot: false,
        isShow: false, //默认选择首页
        linktype: "10",
        http: {
          externalLink: "", //外部链接
          internalLink: "", //内部链接
        },
      },
      {
        path: "find",
        isActive: false, //是否显示当前导航栏
        inactive: "setting",
        /** 图标图片 */
        iconPic: "setting",
        iconName: "发现",
        iconText: "发现",
        /** 是否显示小圆点 */
        isDot: false,
        // 是否显示当前项
        isShow: false,
        // 默认内部链接
        linktype: "10",
        /** 跳转参数 */
        http: {
          externalLink: "",
          internalLink: "",
        },
      },
    ],
  },
});
export default componentProperties;
